import { useCallback, useEffect, useMemo, useState } from "react";
import { getAllEmployeesWeekAttendance } from "../../../../Moduels/attendance/attendanceService";
import { buildWeekDays, formatWeekLabel } from "./attendanceMonthWeek";

export function useAdminAttendanceData(weekStart) {
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const weekDays = useMemo(
    () => (weekStart ? buildWeekDays(weekStart) : []),
    [weekStart]
  );

  const weekLabel = useMemo(
    () => (weekStart ? formatWeekLabel(weekStart) : ""),
    [weekStart]
  );

  const load = useCallback(async () => {
    if (!weekStart) return;
    setLoading(true);
    setError(null);
    try {
      const data = await getAllEmployeesWeekAttendance(weekStart);
      setEmployees(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err?.message || "Failed to load attendance");
      setEmployees([]);
    } finally {
      setLoading(false);
    }
  }, [weekStart]);

  useEffect(() => {
    load();
  }, [load]);

  return { employees, weekDays, weekLabel, loading, error, reload: load };
}
